import { render, staticRenderFns } from "./Sulpak.vue?vue&type=template&id=235ff582&"
import script from "./Sulpak.vue?vue&type=script&lang=js&"
export * from "./Sulpak.vue?vue&type=script&lang=js&"
import style0 from "./Sulpak.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports